import React from 'react'
import RemoveBgPreviewToolbar from './RemoveBgPreviewToolbar'
import RemoveBgPreviewCanvas from './RemoveBgPreviewCanvas'

function RemoveBgPreviewPanel({editor, status, error, retry}) {
    return (
        <div className="RemoveBgEditor__PreviewPanel">
            <RemoveBgPreviewToolbar editor={editor} />
            <RemoveBgPreviewCanvas editor={editor} status={status} error={error} retry={retry} />
        </div>
    )
}

export default RemoveBgPreviewPanel
